import React, { useEffect, useState } from "react";
import { language } from "../../system/types/project/language";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { useLoadTranslations } from "../../hooks/useLoadTranslations";
import { LazyIcon } from "../LazyIcon/LazyIcon";
import { actions, store } from "../../redux";
import { dispatch } from "../../App";
import { localStorageHelper } from "../../system/helper/localStorage";
import { localStorageConfig } from "../../system/config/localStorage";

import "./LanguageSelect.scss";


const LanguageSelect = () => {

    const { loadTranslations } = useLoadTranslations();

    const [languages, setLanguages] = useState<language[]>([]);
    const [activeLanguage, setActiveLanguage] = useState<string>('');
    const [showList, setShowList] = useState<boolean>(false);


    useSelector((state: RootState) => {
        if (state.system.appConfig.availAbleLanguage !== languages) {
            setLanguages(state.system.appConfig.availAbleLanguage);
        }
        if (state.system.appConfig.language !== activeLanguage) {
            setActiveLanguage(state.system.appConfig.language);
        }
    });

    const getClassnameList = ():string => {
        let className = 'list';

        if (showList) {
            className += ' active';
        }

        return className;
    };

    const getClassNameEntry = (isoCode: string): string => {
        let className = 'entry';

        if (isoCode === activeLanguage) {
            className += ' show';
        }

        return className;
    };

    const entrySelected = (isoCode: string) => {
        if (!showList) {
            setShowList(true);
            return;
        }

        const state = store.getState();

        const newAppConfig = {
            ...state.system.appConfig,
            language: isoCode
        };

        dispatch(actions.system.setAppConfig(newAppConfig));

        const localStorage = new localStorageHelper();
        localStorage.setItem(localStorageConfig.languageIso, isoCode);

        setShowList(false);
    }

    const chevronSelected = () => {
        setShowList(!showList);
    }

    useEffect(() => {
        loadTranslations();
    }, [activeLanguage]);

    return (<div className="LanguageSelect">
        <div className={getClassnameList()}>
        {languages.map((language)=>(
            <div 
                key={language.isoCode} 
                className={getClassNameEntry(language.isoCode)}
                onClick={() => {
                    entrySelected(language.isoCode);
                }}
            >{language.name}</div>
        ))}
        </div>
        <div className="chevron" onClick={chevronSelected}><LazyIcon icon={"mdiChevronDown"} size={1} /></div>
    </div>);
}

export { LanguageSelect };
